import { forwardRef, type ComponentProps, type ComponentRef } from 'react';
import clsx from 'clsx';
import { Radio as MuiRadio } from '@mui/material';

export type RwRadioProps = ComponentProps<typeof MuiRadio>;

// Wires to rw-ds.css `.rw-radio` (rw-ds-components § Radio) — single-select control,
// styled analogue of `RwCheckbox`'s box treatment (navy-neutral fill, focus ring).

export const RwRadio = forwardRef<ComponentRef<typeof MuiRadio>, RwRadioProps>(function RwRadio({ className, ...props }, ref) {
  return <MuiRadio ref={ref} className={clsx('rw-radio', className)} {...props} />;
});
